export default "__VITE_ASSET__$tKHvi$9__"